var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4591_3760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 4.6145H2.5C2.33424 4.6145 2.17527 4.68035 2.05806 4.79756C1.94085 4.91477 1.875 5.07374 1.875 5.2395V15.8645C1.875 16.196 2.0067 16.514 2.24112 16.7484C2.47554 16.9828 2.79348 17.1145 3.125 17.1145H16.875C17.2065 17.1145 17.5245 16.9828 17.7589 16.7484C17.9933 16.514 18.125 16.196 18.125 15.8645V5.2395C18.125 5.07374 18.0592 4.91477 17.9419 4.79756C17.8247 4.68035 17.6658 4.6145 17.5 4.6145ZM16.875 15.8645H3.125V6.6606L9.57734 12.5754C9.69265 12.6813 9.84348 12.74 10 12.74C10.1565 12.74 10.3074 12.6813 10.4227 12.5754L16.875 6.6606V15.8645Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4591_3760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.864502)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEMail);
export default __webpack_public_path__ + "static/media/E-Mail.72f10ab8530875fcc2a67c7f9b41827e.svg";
export { ForwardRef as ReactComponent };